import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../assets/css/Variant/AddVariantName.css'
const API_BASE_URL = process.env.REACT_APP_API_URL;
const AddEditVariantName = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // undefined in Add mode
  const isEdit = !!id;

  const [form, setForm] = useState({
    name: '',
    code: '',
    remarks: '',
    status: true,
  });

  useEffect(() => {
    if (isEdit) {
      const fetchVariant = async () => {
        const token = localStorage.getItem('token');
        try {
          const res = await axios.get(`${API_BASE_URL}/api/variant-names/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setForm(res.data);
        } catch (error) {
          alert('Failed to load data.');
        }
      };
      fetchVariant();
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      if (isEdit) {
        await axios.put(`${API_BASE_URL}/api/variant-names/${id}`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API_BASE_URL}/api/variant-names`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      navigate('/variant-name');
    } catch (error) {
      alert(error.response?.data?.message || 'Submission failed.');
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* Title with custom class */}
        <h4 className="variant-title">{isEdit ? 'Edit' : 'Add'} Variant Name</h4>

        {/* Back button with custom class */}
        <button className="back-button" onClick={() => navigate('/variant-name')}>
          ← Back
        </button>
      </div>

      {/* Card with custom header class */}
      <div className="card shadow">
        <div className="card-header variant-header text-white fw-semibold">
          {isEdit ? 'Edit Variant' : 'Create Variant'}
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={form.name}
                  required
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={form.code}
                  required
                  onChange={(e) => setForm({ ...form, code: e.target.value })}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.remarks}
                  onChange={(e) => setForm({ ...form, remarks: e.target.value })}
                />
              </div>
              <div className="col-md-6 d-flex align-items-center mt-4">
                <label className="form-check-label me-2">Status</label>
                <div className="form-check form-switch">
                  <input
                    className={`form-check-input ${form.status ? 'bg-success' : 'bg-danger'}`}
                    type="checkbox"
                    checked={form.status}
                    onChange={(e) => setForm({ ...form, status: e.target.checked })}
                  />
                  <span className={`ms-2 fw-semibold ${form.status ? 'text-success' : 'text-danger'}`}>
                    {form.status ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <button type="button" className="btn btn-secondary me-2" onClick={() => navigate('/variant-name')}>
                Cancel
              </button>
              <button type="submit" className="btn btn-success">
                {isEdit ? 'Update' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEditVariantName;
